import React from 'react';
import { NavLink } from 'react-router-dom';
import ScrollToTop from 'components/scroll-to-top';
import PartnersList from 'components/partners-list';


import './style.css';

const HomePage = () => (
  <div className="l-about-page">
    <ScrollToTop />
    <div className="products-header -single">
      <h1>
        We care about <br />
        the air we breathe.
      </h1>
      <p>
        Air Quality information based on satellite data delivered by the lead worldwide providers.
      </p>
      <p>
        We are a multidisciplinary team including business developers, social scientists, engineers,
        satellite experts, software & tools developers, forecast modellers and communication and design specialists.
      </p>
    </div>
    <div className="about-organisations">
      <PartnersList />
    </div>
    <div className="container">
      <div className="row">
        <div className="col">
          <div className="about-contact">
            <NavLink className="c-button -contact" to="/contact-us">
              Contact
            </NavLink>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default HomePage;



// WEBPACK FOOTER //
// ./src/pages/about/index.js